import { CalendarManager, Company, FDA, FdaCalendarParams, ISetParams, Security } from '@benzinga/calendar-manager';
import { Session } from '@benzinga/session';
import { fetchTickersLogos } from '../lib/utils';
import { logCalendarFetchFailure } from '../lib/utils/logCalendarFetchFailure';

export const FDACalendarTabKeys: ('historical' | 'exact-dates' | 'estimated-dates' | 'pdufa')[] = [
  'historical',
  'exact-dates',
  'estimated-dates',
  'pdufa',
];

export type FDACalendarTabKeysType = (typeof FDACalendarTabKeys)[number];

const fetchFDA = async (
  session: Session,
  params: ISetParams = {},
  tabKey?: FDACalendarTabKeysType,
  pageSize = 100,
): Promise<FDA[]> => {
  try {
    const query = {
      ...params,
      dateSortStrict: false,
      pageSize: pageSize,
    } as FdaCalendarParams;

    if (tabKey === 'exact-dates' || tabKey === 'estimated-dates' || tabKey === 'pdufa') {
      query.dateSearchField = 'target';
    } else {
      query.dateSearchField = 'announced';
    }

    const calendarManager = session.getManager(CalendarManager);

    let items: FDA[] = [];
    const res = await calendarManager.getCalendarData('fda', query);

    if (res.ok) {
      items = res.ok;
    }

    let logos: Record<string, string> | null = null;
    const tickers: string[] = [];

    if (items.length > 0) {
      items.forEach(item => {
        if (item.companies && item.companies.length > 0) {
          item.companies.forEach((c: Company) => {
            if (c.securities && c.securities.length > 0) {
              c.securities.forEach((s: Security) => {
                tickers.push(s.symbol);
              });
            }
          });
        }
      });
      logos = await fetchTickersLogos(tickers);

      if (logos && Object.keys(logos).length > 0) {
        items.forEach(item => {
          if (item.companies && item.companies.length > 0) {
            item.companies.forEach((c: Company) => {
              if (c.securities && c.securities.length > 0) {
                c.securities.forEach((s: Security) => {
                  if (logos && logos[s.symbol]) {
                    s['logo'] = logos[s.symbol];
                  }
                });
              }
            });
          }
        });
      }
    }

    return items;
  } catch (error) {
    logCalendarFetchFailure('fda', error);
    return [];
  }
};

export { fetchFDA };
